import { IonContent } from '@ionic/react';
import { PhotoGrid } from '@square-photo/components/photo-grid';
import type { PhotoFile } from '@square-photo/types';

export interface ProcessingScreenProps {
  photos: PhotoFile[];
}

/**
 * 轉換中的畫面：只有縮圖，進度與提示在工具列上（見 PhotoApp）。
 *
 * 這一段沒有任何可按的東西——轉換途中沒有能安全中止的路徑（Worker 正持有
 * ImageBitmap 的所有權），與其擺一顆按了會讓狀態不一致的取消鍵，不如不擺。
 */
export function ProcessingScreen({ photos }: ProcessingScreenProps) {
  return (
    <IonContent>
      <div className="p-1 md:p-1.5">
        <PhotoGrid photos={photos} showRemoveButton={false} />
      </div>
    </IonContent>
  );
}
